// tslint:disable-next-line: max-line-length
import {
  Component,
  OnDestroy,
  OnInit,
  DoCheck,
  forwardRef,
  ViewChildren,
  QueryList,
  ViewEncapsulation,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  Directive,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ServerModel } from "../../../shared/models/server.model";
import { MasterService } from "../../../shared/services/master.service";
import { ServersService } from "../../../shared/services/servers.service";
import { SensorsService } from "../../../shared/services/sensors.service";
import { SiteModel } from "../../../shared/models/site.model";
import { Subscription } from "rxjs/Subscription";
import { SitesService } from "../../../shared/services/sites.service";
import { CustomValidators } from "../../../shared/validators/custom.validators";
import { DataService } from "../../../shared/services/data.service";
import { Data } from "@angular/router";
import { SensorModel } from "../../../shared/models/sensor.model";
import { validators } from "validate.js";
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from "@angular/forms";
import { NgxIpBase } from "ngx-ip";


@Component({
  selector: "lba-createSite",
  templateUrl: "./create-sensor.component.html",
  styleUrls: ["./create-sensor.component.scss"],
})
export class CreateSensorComponent
  extends NgxIpBase
  implements OnInit, OnDestroy, DoCheck {
  //  @ViewChildren('input') public matInputs: QueryList<MatInput>;
  modalHeader: string = "Add Sensor";
  form: FormGroup;
  servers: ServerModel[] = [];
  server: any;
  serverName: string = "";

  sensor: SensorModel = new SensorModel();
  sensorId: number;
  hardwareTypeId: any = 9;
  initialized: boolean = false;
  monitoringLagMinutes: any = 5;
  macWlan: string;
  macEth: any = null;
  isValidMac = require("is-mac-address");

  subscription: Subscription;

  isLoaded: boolean = false;

  searchStr: string = "";

  constructor(
    cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private masterService: MasterService,
    private serverService: ServersService,
    private sensorService: SensorsService,
    private dataService: DataService,
    private changeDetector: ChangeDetectorRef
  ) {
    super(cdr);
  }

  closeModal(sensor?: SensorModel) {
    this.activeModal.close(sensor);
  }

  ngOnInit() {
    if (this.sensor.id === 0) {
      this.sensor.hardwareTypeId = this.hardwareTypeId;
      this.sensor.initialized = this.initialized;
      this.sensor.monitoringLagMinutes = this.monitoringLagMinutes;
      this.sensor.macEth = this.macEth;
    }
    //  console.log('sensor Id', this.sensorId);
    this.sensor.hardwareTypeId = this.hardwareTypeId;
    this.sensor.initialized = this.initialized;
    this.sensor.monitoringLagMinutes = this.monitoringLagMinutes;
    this.sensor.macEth = this.macEth;

    this.subscription = this.serverService.getServers().subscribe(
      (data: ServerModel[]) => {
        this.servers = data.filter((server) => server.deploymentStatus > 0);
        this.server = this.servers[0];
        // this.serverName = this.servers[0].name;
        this.serverName = "Select";
        this.isLoaded = true;
        //    console.log('Server ID: ', this.servers);
      },
      (error) => {
        console.log(error);
        window.alert(
          "Error: " + error.message + ", error status: " + error.status
        );
      }
    );
    this.configureUI();
  }

  configureUI() {
    this.form = new FormGroup({
      // 'sensorId': new FormControl(null, Validators.required),
      description: new FormControl(null, Validators.maxLength(200)),
      hardwareTypeId: new FormControl({ value: "9", disabled: true }),
      serverId: new FormControl(null),
      initialized: new FormControl({ value: "False", disabled: true }),
      monitoringLagMinutes: new FormControl({ value: "5", disabled: true }),
      location: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
      // tslint:disable-next-line: max-line-length
      macWlan: new FormControl(null, [
        Validators.required,
        Validators.pattern("^[a-fA-F0-9]{2}(?:[:]?[a-fA-F0-9]{2}){5}$"),
      ]),
      macEth: new FormControl({ value: "NULL", disabled: true }),
    });
    this.updateValues();
  }

  updateValues() {
    this.form.setValue({
      description: this.sensor.description,
      hardwareTypeId: this.sensor.hardwareTypeId,
      serverId: this.sensor.serverId,
      initialized: this.sensor.initialized,
      monitoringLagMinutes: this.sensor.monitoringLagMinutes,
      location: this.sensor.location,
      macWlan: this.sensor.macWlan,
      macEth: this.sensor.macEth,
    });
  }

  ngDoCheck() {
    this.changeDetector.detectChanges();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  submit() {
    const formData = this.form.value;

    this.sensor.description = formData.description;
    // this.sensor.hardwareTypeId = formData.hardwareTypeId;
    // this.sensor.serverId = formData.serverId;
    this.sensor.initialized = formData.initialized;
    this.sensor.monitoringLagMinutes = formData.monitoringLagMinutes;
    this.sensor.location = formData.location;
    this.sensor.macWlan = formData.macWlan;
    this.sensor.macEth = formData.macEth;

    //  console.log('Submitted HardwareTypeId: ', this.sensor.hardwareTypeId);
    //  console.log('Submitted ServerID: ', this.sensor.serverId);
    if (this.sensor.serverId !== 0) {
      this.sensorService.createSensor(this.sensor).subscribe(
        (newSensor: SensorModel) => {
          // tslint:disable-next-line: max-line-length
          window.alert(
            "Sensor: " +
              newSensor.id +
              " was successfully created on server: " +
              newSensor.serverName +
              "."
          );
          const sensorToSend = new SensorModel(
            newSensor.id,
            newSensor.id,
            newSensor.description,
            newSensor.hardwareTypeId,
            newSensor.hardwareType,
            newSensor.serverId,
            newSensor.macEth,
            newSensor.macWlan,
            newSensor.initialized,
            newSensor.monitoringLagMinutes,
            newSensor.status,
            newSensor.softwareVersion,
            newSensor.location,
            newSensor.region,
            newSensor.lastTimeSeen,
            newSensor.sites
          );
          console.log("Sensor ID after creation: ", newSensor.id);
          this.closeModal(sensorToSend);
          if (this.sensor.id === 0) {
            this.sensor.id = newSensor.id;
          }
        },
        (error) => {
          console.log(error);
          window.alert(
            "Error: " + error.message + ", error status: " + error.status
          );
        },
        () => {}
      );
    } else if (this.sensor.serverId === 0) {
      window.alert("Please choose a server!");
    }
  }

  onChooseServer(server: ServerModel) {
    this.serverName = server.name;
    this.sensor.serverId = server.id;
    // this.updateServerAndSensorId();
    //   console.log('Chosen ServerID: ', this.sensor.serverId);
  }

  //     onChangeLocal(value: string, idx: number, input: MatInput): void {
  //         const errorCount = this.errorCount;
  //         super.onChange(value, idx);
  //         if (this.errorCount === 0 && errorCount > 0) {
  //           const arr = this.matInputs.toArray();
  //           for (let i of arr) {
  //             if (i.errorState) {
  //               i.errorState = false;
  //               i.stateChanges.next();
  //             }
  //           }
  //         } else {
  //           this.markErrorState(idx, input);
  //         }
  //       }

  //       protected paste(data: string, blockIndex: number): boolean {
  //         if (super.paste(data, blockIndex)) {
  //           const arr = this.matInputs.toArray();
  //           for (let i = 0, len = arr.length; i < len; i++) {
  //             this.markErrorState(i, arr[i]);
  //           }
  //           return true;
  //         }
  //         return false;
  //       }

  //       protected focusNext(idx: number, selectRange: boolean = true): void {
  //         // the parent focusNext deals with DOM element (ElementRef) focus() method
  //         // we add calling the MatInput instance focus() method.
  //         const next = this.matInputs.toArray()[idx + 1];
  //         if (next) {
  //           next.focus();
  //         }
  //         super.focusNext(idx, selectRange);
  //       }

  //       private markErrorState(idx: number, input: MatInput) {
  //         const hasError = this.invalidBlocks[idx];
  //         if (hasError !== input.errorState) {
  //           input.errorState = hasError;
  //           input.stateChanges.next();
  //         }
  //       }

  // }
}
